import { render, staticRenderFns } from "./AssistMaterialUnitInformationRemoveBackground.vue?vue&type=template&id=a152c7c2&scoped=true&lang=pug&"
import script from "./AssistMaterialUnitInformationRemoveBackground.vue?vue&type=script&lang=ts&"
export * from "./AssistMaterialUnitInformationRemoveBackground.vue?vue&type=script&lang=ts&"
import style0 from "./AssistMaterialUnitInformationRemoveBackground.vue?vue&type=style&index=0&id=a152c7c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a152c7c2",
  null
  
)

export default component.exports